import {
  CreateFormTemplateRequest,
  FormTemplateResponse,
  FormTemplateWithUsageResponse,
  UpdateFormTemplateRequest,
} from 'mapistry-shared';
import http from '../httpClient';

export type GenerateFormTemplateFromPdfVariables = {
  file: File;
  tabIdentifier: string;
};
export type GenerateFormTemplateFromPdfResponse = FormTemplateResponse;
export async function generateFormTemplateFromPdf(
  variables: GenerateFormTemplateFromPdfVariables,
) {
  const { file, tabIdentifier } = variables;

  const formData = new FormData();
  formData.append('file', file);

  const res = await http.post<GenerateFormTemplateFromPdfResponse>(
    `/api/v2/form-templates/generated/${tabIdentifier}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return res.data;
}

export type CreateFormTemplateResponse = FormTemplateResponse;
export async function createFormTemplate(
  formTemplate: CreateFormTemplateRequest,
) {
  const res = await http.post<CreateFormTemplateResponse>(
    `/api/v2/form-templates`,
    formTemplate,
  );
  return res.data;
}

export type FetchFormTemplateParams = { slug: string; organizationId: string };

export async function fetchFormTemplate({
  slug,
  organizationId,
}: FetchFormTemplateParams) {
  const res = await http.get<FormTemplateWithUsageResponse>(
    `/api/v2/organizations/${organizationId}/form-templates/${slug}`,
  );
  return res.data;
}

interface UpdateFormTemplateParams {
  formTemplate: UpdateFormTemplateRequest;
  formTemplateId: string;
  organizationId: string;
}

export type UpdateFormTemplateResponse = FormTemplateWithUsageResponse;
export async function updateFormTemplate({
  formTemplate,
  formTemplateId,
  organizationId,
}: UpdateFormTemplateParams): Promise<UpdateFormTemplateResponse> {
  const res = await http.put<UpdateFormTemplateResponse>(
    `/api/v2/organizations/${organizationId}/form-templates/${formTemplateId}`,
    formTemplate,
  );
  return res.data;
}
